export function formatMask(regExp: RegExp): string {
  const pattern = regExp.source.replace(/^\^|\$$/g, '');

  return pattern
    .replace(/\\d\{(\d+)\}/g, (_, n) => '0'.repeat(+n))
    .replace(/\\d/g, '0')
    .replace(/\[A-Z]\{(\d+)\}/g, (_, n) => 'A'.repeat(+n))
    .replace(/\[A-Z]/g, 'A')
    .replace(/\\/g, '');
}

export function formatValueAccordingToRegExp(value: string, regExp: RegExp): string | null {
  if (!value) return '';

  const cleaned = value.trim().replace(/\s+/g, ' ');

  if (regExp.test(cleaned)) return cleaned;

  const mask = formatMask(regExp);

  const digits = cleaned.replace(/\D/g, '');
  const letters = cleaned.replace(/[^A-Z]/gi, '').toUpperCase();

  let digitIndex = 0;
  let letterIndex = 0;

  const formatted = mask
    .split('')
    .map((ch) => {
      if (ch === '0') return digits[digitIndex++] ?? '';
      if (ch === 'A') return letters[letterIndex++] ?? '';
      return ch;
    })
    .join('')
    .trim();

  return regExp.test(formatted) ? formatted : null;
}

export function formatPhoneNumber(value: string, pattern: string): string | null {
  const regExp = new RegExp(pattern);
  return formatValueAccordingToRegExp(value, regExp);
}
